/* eslint-disable react/prop-types */
import {Link} from 'react-router-dom';
import {
    FileUnknownFilled,
    HourglassFilled,
    FileSearchOutlined,
    ExperimentOutlined,
    CrownOutlined,
    ToolOutlined,
    DollarOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons';

import Title from '../../../components/ui/Title';
import SimpleCard from '../../../components/ui/SimpleCard/SimpleCard';

const CommercialIndicator = ({
    totalDealsAwaitingResponseItems,
    totalDealsPendingItems,
    specificationsAsked,
    specificationsStudy,
    won,
    produced,
    billed,
    done,
    lost,
    currentDate
}) => {

    const salesAnsweringIcon = <FileUnknownFilled style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const salesWaitingIcon = <HourglassFilled style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const specificationsAskedIcon = <FileSearchOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const specificationsStudyIcon = <ExperimentOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const wonIcon = <CrownOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const producedIcon = <ToolOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const billedIcon = <DollarOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;
    const lostIcon = <CloseCircleOutlined style={{ fontSize: '30px', color: '#ffff' }} twoToneColor="#ffff"/>;


    return (
        <div className='my-10'>
            <Title title={currentDate} textSize='text-3xl'/>
            <div className='flex flex-wrap justify-between mt-5 gap-x-4 gap-y-5'>
                {/* Étapes initiales - Analyse et qualification */}
                <Link style={{width: '49%'}} to='specifications-asked'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={specificationsAskedIcon}
                        title={specificationsAsked ?? '-'}
                        subTitle="Cahier des charges demandé"
                        hoverEffect={true}
                    />
                </Link>
                <Link style={{width: '49%'}} to='specifications-study'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={specificationsStudyIcon}
                        title={specificationsStudy ?? '-'}
                        subTitle="Étude cahier des charges"
                        hoverEffect={true}
                    />
                </Link>

                {/* Étapes de réponse */}
                <Link style={{width: '49%'}} to='pending-proposals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={salesWaitingIcon}
                        title={totalDealsPendingItems ?? '-'}
                        subTitle="Réponse en cours"
                        hoverEffect={true}
                    />
                </Link>
                <Link style={{width: '49%'}} to='answering-proposals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={salesAnsweringIcon}
                        title={totalDealsAwaitingResponseItems ?? '-'}
                        subTitle="Offre remise"
                        hoverEffect={true}
                    />
                </Link>

                {/* Résultats */}
                <Link style={{width: '49%'}} to='lost-deals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={lostIcon}
                        title={lost ?? '-'}
                        subTitle="Perdue"
                        hoverEffect={true}
                    />
                </Link>

                {/* Cycle de production */}
                <Link style={{width: '49%'}} to='won-deals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={wonIcon}
                        title={won ?? '-'}
                        subTitle="Gagnée"
                        hoverEffect={true}
                    />
                </Link>
                <Link style={{width: '49%'}} to='produced-deals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={producedIcon}
                        title={produced ?? '-'}
                        subTitle="Produite"
                        hoverEffect={true}
                    />
                </Link>

                {/* Finalisation */}
                <Link style={{width: '49%'}} to='billed-deals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={billedIcon}
                        title={billed ?? '-'}
                        subTitle="Facturée"
                        hoverEffect={true}
                    />
                </Link>
                <Link style={{width: '49%'}} to='closed-deals'>
                    <SimpleCard
                        width='w-full'
                        iconComponent={wonIcon}
                        title={done ?? '-'}
                        subTitle="Close"
                        hoverEffect={true}
                    />
                </Link>
            </div>
        </div>
    )
}

export default CommercialIndicator